export const STOP_TRACKING = 'STOP_TRACKING'
export const LOAD_TRACKING = 'LOAD_TRACKING'
